import { Component, OnInit, computed, effect, inject, input } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ReferenceMeasurementItemLengthComponent } from "@components/reference-measurement-item-length/reference-measurement-item-length.component";
import { FloorplanItem } from "@domain/project/floorplan/floorplan-item";
import { ProtectiveTube } from "@domain/project/floorplan/wiring/protective-tube";
import { DisabledController } from "@odx/angular";
import { FormDirective, FormFieldComponent, FormFieldControlDirective } from "@odx/angular/components/form-field";
import { FloorplanItemDetailsComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-item-details/floorplan-item-details.component";

@Component({
  selector: "app-protective-tube-notes",
  imports: [
    FloorplanItemDetailsComponent,
    FormDirective,
    FormFieldComponent,
    FormFieldControlDirective,
    FormsModule,
    ReactiveFormsModule,
    DisabledController,
    ReferenceMeasurementItemLengthComponent,
  ],
  templateUrl: "./protective-tube-notes.component.html",
  styleUrl: "./protective-tube-notes.component.scss",
  standalone: true,
})
export class ProtectiveTubeNotesComponent implements OnInit {
  private readonly formBuilder = inject(FormBuilder);

  readonly floorplanItem = input.required<FloorplanItem>();
  protected readonly protectiveTube = computed(() => this.floorplanItem() as ProtectiveTube);

  protected protectiveTubeForm?: FormGroup;

  constructor() {
    effect(() => {
      const protectiveTube = this.protectiveTube();
      this.protectiveTubeForm?.reset(
        {
          name: [protectiveTube.name],
          material: [protectiveTube.material],
        },
        { emitEvent: false },
      );
    });
  }

  ngOnInit() {
    this.initForm();
  }

  private update(): void {
    this.protectiveTube().updateMetadata(this.protectiveTubeForm!.value.material, this.protectiveTubeForm!.value.name);
    this.protectiveTube().name = this.protectiveTubeForm!.value.name;
  }

  private initForm() {
    this.protectiveTubeForm = this.formBuilder.group({
      name: [this.protectiveTube().name],
      material: [this.protectiveTube().material],
    });

    this.protectiveTubeForm.valueChanges.subscribe(() => {
      if (!this.protectiveTubeForm!.valid || this.protectiveTubeForm!.pristine) return;
      this.update();
    });
  }
}
